import { useAnalytics } from '@lib/analytics/analyticsContext';
import { useEffect, useMemo, useRef } from 'react';

import { VideoAnalytics } from '../utils/videoAnalytics';

const SAMPLING_RATE = 0.5;

export const useVideoAnalytics = (vid?: HTMLVideoElement) => {
    const videoAnalytics = useRef<VideoAnalytics | null>(null);
    const { track } = useAnalytics();
    const shouldMonitor = useMemo(() => Math.random() < SAMPLING_RATE, []);
    useEffect(() => {
        if (!vid) return;
        if (!shouldMonitor) return;
        videoAnalytics.current = new VideoAnalytics(vid, track);
    }, [vid, track, shouldMonitor]);

    return { videoAnalytics: videoAnalytics.current };
};
